export default __webpack_public_path__ + "static/code-person-background-22d2fbb75e46c5656fb3e91f3ee6e6b6.jpeg";